import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { FlightBookingDetails } from "../../Services/API"

const PrintTicket = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const referenceNo = queryParams.get("ReferenceNo");
    const key = queryParams.get("key");
    const clientCode = queryParams.get("clientCode");
    const trackID = queryParams.get("trackID");

    const [flightDetails, setFlightDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [sector, setSector] = useState(null);

    useEffect(() => {
        if (referenceNo && trackID) {
            fetchFlightBookingDetails(referenceNo, trackID);
        } else {
            console.warn("Missing referenceNo or trackID");
        }
    }, [referenceNo, trackID]);


    useEffect(() => {
        if (!loading && flightDetails) {

            const waitForImages = async () => {
                const images = Array.from(document.images);

                await Promise.all(
                    images.map(img => {
                        if (img.complete) return Promise.resolve();

                        return new Promise(resolve => {
                            img.onload = resolve;
                            img.onerror = resolve;
                        });
                    })
                );

                setTimeout(() => {
                    window.focus();
                    window.print();
                }, 300);
            };

            waitForImages();
        }
    }, [loading, flightDetails]);

    const fetchFlightBookingDetails = async (referenceNo, trackID) => {
        try {
            setLoading(true);
            setError("");
            const params = { ReferenceNo: referenceNo, TrackID: trackID, ClientCode: "BerryJourneys", Key: "", SessionID: "" };
            const response = await FlightBookingDetails(params);
            var BookingResponse = response?.airBookingResponse[0];
            var Sectors = BookingResponse.origin + "-" + BookingResponse.destination;
            setSector(Sectors);
            setFlightDetails(response);
            console.log("FlightBookingDetails", response);
        } catch (err) {
            setError("Failed to load flight Booking details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "";

        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };
    const formatDateTime = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "";

        return date.toLocaleString("en-IN", {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const gstRequest = flightDetails?.gstRequest || {};

    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}

            {loading && (
                <div style={{ background: '#fff', margin: '0 auto', width: '1000px' }}>
                    <p style={{ textAlign: "center" }}>
                        Loading ticket details...
                    </p>
                </div>
            )}

            {flightDetails && flightDetails.airBookingResponse.length > 0 && (
                <>
                    <div style={{ background: '#fff', margin: '0 auto', width: '1000px' }}>
                        <table style={{ background: "#fff", width: "100%", margin: "0 auto" }} class="">
                            <tbody>
                                <tr>
                                    <td>
                                        <table width="100%">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table style={{ width: "100%" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td
                                                                        style={{ width: "60%", padding: "15px 40px" }}
                                                                        className="print_logo"
                                                                    >
                                                                        <img src="/assets/images/logo.png" width={250} />
                                                                    </td>

                                                                    <td style={{ width: "40%" }}>
                                                                        <p>
                                                                            <strong className="printSmTxt">
                                                                                {flightDetails.corporateDetails?.companyName}
                                                                            </strong>
                                                                        </p>

                                                                        <p>
                                                                            <span
                                                                                className="printSmTxt"
                                                                                style={{ fontWeight: 400, fontSize: "14px", color: "#110942" }}
                                                                            >
                                                                                Email: {flightDetails.corporateDetails?.email}
                                                                            </span>
                                                                        </p>

                                                                        <p>
                                                                            <span
                                                                                className="printSmTxt"
                                                                                style={{ fontWeight: 400, fontSize: "14px", color: "#110942" }}
                                                                            >
                                                                                Phone: {flightDetails.corporateDetails?.phoneNumber}
                                                                            </span>
                                                                        </p>

                                                                        <p>
                                                                            <span
                                                                                className="printSmTxt"
                                                                                style={{ fontWeight: 400, fontSize: "14px", color: "#110942" }}
                                                                            >
                                                                                Address: {flightDetails.corporateDetails?.address} {flightDetails.corporateDetails?.city} {flightDetails.corporateDetails?.state} - {flightDetails.corporateDetails?.pinCode}
                                                                            </span>
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                        {flightDetails && flightDetails?.airBookingResponse[0]?.flightDetails?.map((segment, index) => (
                                                            <React.Fragment key={index}>
                                                                <table style={{ width: "100%" }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td
                                                                                className="printBookingDetail"
                                                                                style={{
                                                                                    width: "50%",
                                                                                    border: "1px solid #333",
                                                                                    borderLeft: 0,
                                                                                    padding: "8px",
                                                                                }}
                                                                            >
                                                                                <p style={{ marginBottom: "5px", color: "#110942" }}>
                                                                                    {/* Booking Time: Jan 6, 2026 12:08 PM */}
                                                                                    <strong>Booking Time:</strong>{" "}{formatDate(flightDetails.airBookingResponse[0]?.bookingDate)}
                                                                                </p>

                                                                                <p style={{ marginBottom: "5px", color: "#110942" }}>
                                                                                    {/* Booking ID: {flightDetails.transactionID} */}
                                                                                    Booking ID: {flightDetails.referenceNo}
                                                                                </p>

                                                                                <p style={{ marginBottom: "5px", color: "#110942" }}>
                                                                                    Booking Status: <strong style={{ color: "#110942" }}>{flightDetails.airBookingResponse[0].bookingStatus}</strong>
                                                                                </p>
                                                                            </td>

                                                                            <td
                                                                                className="printAirlineDetail"
                                                                                style={{
                                                                                    width: "50%",
                                                                                    borderTop: "1px solid #333",
                                                                                    borderBottom: "1px solid #333",
                                                                                    padding: "5px",
                                                                                }}
                                                                            >
                                                                                <br />

                                                                                <table style={{ width: "100%", marginBottom: "15px" }}>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td style={{ width: "40px" }}>

                                                                                                <img
                                                                                                    className="reviewbox__airlineLogo"
                                                                                                    src={`https://travel.berryjourneys.com/assets/images/Flight_Images/${segment.airLineCode}.gif`}
                                                                                                    style={{
                                                                                                        marginRight: "5px",
                                                                                                        verticalAlign: "middle",
                                                                                                        width: "30px",
                                                                                                    }}
                                                                                                    alt={segment.airLineName}
                                                                                                />
                                                                                            </td>

                                                                                            <td style={{ width: "40%" }}>
                                                                                                <p style={{ fontSize: "14px" }}>{segment.airLineName}</p>
                                                                                            </td>

                                                                                            <td>
                                                                                                <p style={{ fontWeight: "bold", fontSize: "20px" }}>
                                                                                                    {flightDetails.airBookingResponse[0].pnr}
                                                                                                </p>
                                                                                                <p style={{ fontSize: "14px", color: "#110942" }}>
                                                                                                    Airline PNR
                                                                                                </p>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <table style={{ width: "100%" }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td
                                                                                width="20%"
                                                                                style={{ padding: "2px", fontSize: "14px", paddingLeft: "20px" }}
                                                                            >
                                                                                <p>
                                                                                    <strong className="printSmTxt" style={{ color: "#110942" }}>
                                                                                        {segment.airLineCode} - {segment.flightNumber}
                                                                                    </strong>
                                                                                </p>
                                                                                <p>
                                                                                    <span style={{ fontWeight: 400 }}>{segment.airLineName}</span>
                                                                                </p>
                                                                            </td>

                                                                            {/* <td width="10%" style={{ padding: "2px", fontSize: "14px" }}>
                                                                                <p><span style={{ fontWeight: 400 }}>NA</span></p>
                                                                            </td> */}

                                                                            <td width="10%" style={{ padding: "2px", fontSize: "14px" }}>
                                                                                <p><span style={{ fontWeight: 400 }}>{segment.travelClass || "-"}</span></p>
                                                                            </td>

                                                                            {/* <td width="10%" style={{ padding: "2px", fontSize: "14px" }}>
                                                                                <p><span style={{ fontWeight: 400 }}>Refundable</span></p>
                                                                            </td> */}

                                                                            <td width="20%" style={{ padding: "2px", fontSize: "14px" }}>
                                                                                <p>
                                                                                    <strong className="printSmTxt" style={{ color: "#110942" }}>
                                                                                        {formatDateTime(segment.departDateTime)}
                                                                                    </strong>
                                                                                </p>
                                                                                <p><span style={{ fontWeight: 400 }}>{segment.departCityName}</span></p>
                                                                                <p><span style={{ fontWeight: 400 }}>{segment.departAirportName}</span></p>
                                                                                <p><span style={{ fontWeight: 400 }}>{
                                                                                    segment.departTerminal
                                                                                        ? ` ${segment.departTerminal.toLowerCase().includes("terminal")
                                                                                            ? segment.departTerminal
                                                                                            : `Terminal ${segment.departTerminal}`
                                                                                        }`
                                                                                        : ""
                                                                                }</span></p>
                                                                            </td>

                                                                            <td width="20%" style={{ padding: "2px", fontSize: "14px" }}>
                                                                                <p>
                                                                                    <strong className="printSmTxt" style={{ color: "#110942" }}>
                                                                                        {formatDateTime(segment.arrivalDateTime)}
                                                                                    </strong>
                                                                                </p>
                                                                                <p><span style={{ fontWeight: 400 }}>{segment.arrivalCityName}</span></p>
                                                                                <p><span style={{ fontWeight: 400 }}>{segment.arrivalAirportName}</span></p>
                                                                                <p><span style={{ fontWeight: 400 }}>{
                                                                                    segment.arrivalTerminal
                                                                                        ? ` ${segment.arrivalTerminal.toLowerCase().includes("terminal")
                                                                                            ? segment.arrivalTerminal
                                                                                            : `Terminal ${segment.arrivalTerminal}`
                                                                                        }`
                                                                                        : ""
                                                                                }</span></p>
                                                                            </td>

                                                                            <td width="10%" style={{ padding: "2px", fontSize: "14px" }}>
                                                                                <p>
                                                                                    <strong className="printSmTxt" style={{ color: "#110942" }}>
                                                                                        Duration
                                                                                    </strong>
                                                                                </p>
                                                                                <p><span style={{ fontWeight: 600, color: "#110942" }}>{segment.duration} </span>
                                                                                    <span>Hrs</span>
                                                                                </p>
                                                                                <p>
                                                                                    <strong className="printSmTxt" >

                                                                                    </strong>
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </React.Fragment>
                                                        ))}



                                                        {/* Passenger Header */}
                                                        {flightDetails?.airBookingResponse?.[0]?.customerInfo?.passengerTicketDetails?.length > 0 && (
                                                            <>
                                                                <table style={{ marginTop: "12px", width: "100%" }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <p style={{ background: "#110942", color: "#dacd65", padding: "5px 0 5px 20px" }}>
                                                                                    Passenger Details
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>

                                                                {/* Table Header */}
                                                                <table
                                                                    style={{
                                                                        color: "#110942",
                                                                        width: "100%",
                                                                        borderCollapse: "collapse",
                                                                        border: "1px solid #ccc",
                                                                        tableLayout: "fixed",
                                                                    }}
                                                                >
                                                                    <tbody>
                                                                        <tr>
                                                                            {[
                                                                                "Sr.",
                                                                                "Name & FF",
                                                                                "Sector",
                                                                                "PNR & Ticket No.",
                                                                                "Baggage (Check-in | Cabin)",
                                                                                "Meal, Seat & Other Preference",
                                                                                "Document Id",
                                                                            ].map((text, i) => (
                                                                                <td
                                                                                    key={i}
                                                                                    style={{
                                                                                        background: "#110942",
                                                                                        padding: "5px",
                                                                                        textAlign: "center",
                                                                                        fontSize: "14px",
                                                                                        color: "#dacd65",
                                                                                    }}
                                                                                >
                                                                                    {text}
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <table
                                                                    style={{
                                                                        color: "#110942",
                                                                        width: "100%",
                                                                        borderCollapse: "collapse",
                                                                        border: "1px solid #ccc",
                                                                        borderTop: "none",
                                                                        tableLayout: "fixed",
                                                                    }}
                                                                >
                                                                    {/* Passenger Rows */}
                                                                    <tbody>
                                                                        {flightDetails.airBookingResponse?.[0]?.customerInfo?.passengerTicketDetails?.map(
                                                                            (pax, paxIndex) => (
                                                                                <React.Fragment key={paxIndex}>
                                                                                    {/* Main Row */}
                                                                                    <tr>
                                                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                                                            {paxIndex + 1}
                                                                                        </td>

                                                                                        <td
                                                                                            style={{
                                                                                                padding: "5px",
                                                                                                textAlign: "center",
                                                                                                textTransform: "uppercase",
                                                                                            }}
                                                                                        >
                                                                                            {pax.title} {pax.firstName} {pax.lastName}
                                                                                        </td>

                                                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                                                            {sector || "-"}
                                                                                        </td>

                                                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                                                            {pax.ticketNumber || "-"}
                                                                                            {pax.ticketNo && ` / ${pax.ticketNo}`}
                                                                                        </td>

                                                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                                                            {pax.baggage || "-"}
                                                                                        </td>

                                                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                                                            {pax.mealSeatPreference || "-"}
                                                                                        </td>

                                                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                                                            {pax.documentId || ""}
                                                                                        </td>
                                                                                    </tr>

                                                                                    {/* Barcode Row */}
                                                                                    <tr>
                                                                                        <td colSpan="7" style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc", padding: "20px" }}>
                                                                                            <img
                                                                                                src={pax.barCode}
                                                                                                alt="Barcode"
                                                                                                style={{ maxWidth: "100%" }}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                </React.Fragment>
                                                                            )
                                                                        )}
                                                                    </tbody>

                                                                </table>
                                                            </>
                                                        )}

                                                        {/* Barcode */}


                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        {/* Empty spacer table (can be removed if not needed) */}
                        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center" }}>
                            <tbody>
                                <tr />
                                <tr />
                            </tbody>
                        </table>

                        {/* GST Details Header */}


                        {gstRequest?.gstNumber && (
                            <>
                                <p style={{ background: "#110942", color: "#dacd65", padding: "5px", paddingLeft: "20px" }}>
                                    GST Details
                                </p>
                                <table
                                    style={{
                                        border: "1px solid #333",
                                        width: "100%",
                                        borderCollapse: "collapse",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            {["GST Name", "GST No", "GST Email", "GST Phone", "GST Address"].map(
                                                (heading, index) => (
                                                    <th
                                                        key={index}
                                                        style={{
                                                            border: "1px solid #333",
                                                            padding: "6px",
                                                            background: "#110942",
                                                            color: "#dacd65",
                                                            fontSize: "14px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {heading}
                                                    </th>
                                                )
                                            )}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                {gstRequest?.name || "NA"}
                                            </td>

                                            <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                {gstRequest?.gstNumber || "NA"}
                                            </td>

                                            <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                {gstRequest?.email || "NA"}
                                            </td>

                                            <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                {gstRequest?.contactNo || "NA"}
                                            </td>
                                            <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                {gstRequest?.address || "NA"}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                        )}
                        <table style={{ marginTop: "12px", width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <p style={{ background: "#110942", color: "#dacd65", padding: "5px", paddingLeft: "20px" }}>
                                            Baggage Allowance
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table style={{ border: "1px solid #333", width: "100%" }}>
                            <tbody>
                                <tr>
                                    {["Pax", "Sector", "Baggage", "Cabin Baggage"].map(
                                        (heading, index) => (
                                            <th
                                                key={index}
                                                style={{
                                                    border: "1px solid #333",
                                                    padding: "6px",
                                                    background: "#110942",
                                                    color: "#dacd65",
                                                    fontSize: "14px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {heading}
                                            </th>
                                        )
                                    )}

                                </tr>
                                {flightDetails.airBookingResponse?.[0]?.customerInfo?.passengerTicketDetails?.map(
                                    (pax, paxIndex) => (
                                        <React.Fragment key={paxIndex}>
                                            {/* Main Row */}
                                            <tr>
                                                <td style={{ padding: "5px", textAlign: "center" }}>
                                                    {paxIndex + 1}
                                                </td>



                                                <td style={{ padding: "5px", textAlign: "center" }}>
                                                    {sector || "-"}
                                                </td>


                                                <td style={{ padding: "5px", textAlign: "center" }}>
                                                    {pax.baggage || "-"}
                                                </td>


                                            </tr>


                                        </React.Fragment>
                                    )
                                )}
                            </tbody>
                        </table>


                        {flightDetails?.ssrDetails?.length > 0 && (
                            <>
                                <table style={{ marginTop: "12px", width: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p style={{ background: "#110942", color: "#dacd65", padding: "5px", paddingLeft: "20px" }}>
                                                    SSR Details
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>


                                <table style={{ border: "1px solid #333", width: "100%" }}>
                                    <thead>
                                        <tr>
                                            {[
                                                "Pax",
                                                "Sector",
                                                "SSR Code",
                                                "SSR Type",
                                                "Status",
                                                "Description",
                                            ].map((heading, index) => (
                                                <th
                                                    key={index}
                                                    style={{
                                                        border: "1px solid #333",
                                                        padding: "6px",
                                                        background: "#110942",
                                                        color: "#dacd65",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {heading}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {flightDetails.ssrDetails.map((ssr, index) => (
                                            <tr key={index}>
                                                <td style={{ border: "1px solid #333", padding: "5px", textAlign: "center" }}>
                                                    {ssr.passengerNumber + 1}
                                                </td>

                                                <td style={{ border: "1px solid #333", padding: "5px", textAlign: "center" }}>
                                                    {ssr.departureStation}-{ssr.arrivalStation}
                                                </td>

                                                <td style={{ border: "1px solid #333", padding: "5px", textAlign: "center" }}>
                                                    {ssr.ssrCode}
                                                </td>

                                                <td style={{ border: "1px solid #333", padding: "5px", textAlign: "center" }}>
                                                    {ssr.ssrType}
                                                </td>

                                                <td style={{ border: "1px solid #333", color: "green", padding: "5px", textAlign: "center" }}>
                                                    {ssr.status || "-"}
                                                </td>

                                                <td style={{ border: "1px solid #333", padding: "5px", textAlign: "center" }}>
                                                    {ssr.description || "-"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>
                        )}

                        {flightDetails?.airBookingResponse?.[0]?.fareDetails && (
                            <>
                                <table style={{ marginTop: "12px", width: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p style={{ background: "#110942", color: "#dacd65", padding: "5px", paddingLeft: "20px" }}>
                                                    Fare Details
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table style={{ border: "1px solid #333", width: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942", paddingLeft: "20px" }}>
                                                Base Price
                                            </td>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942" }}>
                                                ₹ {Number(flightDetails.airBookingResponse[0].fareDetails.totalBaseFare).toFixed(2)}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942", paddingLeft: "20px" }}>
                                                Airline Taxes and Fees
                                            </td>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942" }}>
                                                {/* ₹ {Number(flightDetails.airBookingResponse[0].fareDetails.totalOtherTax).toFixed(2)} */}
                                                ₹ {flightDetails.airBookingResponse[0]?.fareDetails?.totalOtherTax + flightDetails.airBookingResponse[0]?.fareDetails?.companyMarkUp}
                                            </td>

                                        </tr>

                                        <tr>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942", paddingLeft: "20px" }}>
                                                Management Fee
                                            </td>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942" }}>
                                                ₹ {Number(flightDetails.airBookingResponse[0].fareDetails.managementFee).toFixed(2)}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942", paddingLeft: "20px" }}>
                                                Meal / Seat / Baggage / Misc Charges
                                            </td>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942" }}>
                                                ₹ {flightDetails.airBookingResponse[0]?.ssrAmount}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942", paddingLeft: "20px" }}>
                                                Management Fee GST
                                            </td>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942" }}>
                                                ₹ {Number(flightDetails.airBookingResponse[0].fareDetails.managementFeeTax).toFixed(2)} (18%)
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{ padding: "3px", fontSize: "14px", color: "#110942", paddingLeft: "20px" }}>
                                                Total Price
                                            </td>
                                            <td style={{ padding: "3px", fontWeight: "bold" }}>
                                                ₹ {flightDetails.airBookingResponse[0]?.grandTotalFare}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                        )}

                        {/* Important Information Header */}
                        <table style={{ marginTop: "12px", width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <p style={{ background: "#110942", color: "#dacd65", padding: "5px", paddingLeft: "20px" }}>
                                            Important Information
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Important Information List */}
                        <ul className="mt-2 pb-10">
                            <li>You must web check-in on the airline website and obtain a boarding pass.</li>
                            <li>Reach the terminal at least 2 hours prior to the departure for domestic flight and 4 hours prior to the departure of international flight.</li>
                            <li>For departure terminal please check with the airline first.</li>
                            <li>Date & Time is calculated based on the local time of the city/destination.</li>
                            <li>Use the Airline PNR for all Correspondence directly with the Airline.</li>
                            <li>For rescheduling/cancellation within 4 hours of the departure time contact the airline directly.</li>
                            <li>Your ability to travel is at the sole discretion of the airport authorities and we shall not be held responsible.</li>
                        </ul>

                        {flightDetails?.bookingConsultants && (
                            <>
                                <p style={{ background: "#110942", color: "#dacd65", padding: "5px", paddingLeft: "20px" }}>
                                    Contact Details
                                </p>
                                <table
                                    style={{
                                        border: "1px solid #333",
                                        width: "100%",
                                        borderCollapse: "collapse",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            {["Name", "Email Id", "Phone Number"].map(
                                                (heading, index) => (
                                                    <th
                                                        key={index}
                                                        style={{
                                                            border: "1px solid #333",
                                                            padding: "6px",
                                                            background: "#110942",
                                                            color: "#dacd65",
                                                            fontSize: "14px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {heading}
                                                    </th>
                                                )
                                            )}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {flightDetails.bookingConsultants?.map(
                                            (item, index) => (
                                                <React.Fragment key={index}>
                                                    {/* Main Row */}
                                                    <tr>
                                                        <td
                                                            style={{
                                                                padding: "5px",
                                                                textAlign: "center",
                                                                textTransform: "uppercase",
                                                            }}
                                                        >
                                                            {item.name}
                                                        </td>

                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                            {item.emailId || "NA"}
                                                        </td>

                                                        <td style={{ padding: "5px", textAlign: "center" }}>
                                                            {item.phoneNo || "NA"}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default PrintTicket;
